import plural from 'system/libs/plural';

import { ToastNotify } from 'reactComponents/ToastNotify/ToastNotify';

import s3, { ACL_PRIVATE } from '../../s3';

export const BUCKET_OBJECTS_MULTI_ACL_CHANGE_START =
    'BUCKET_OBJECTS_MULTI_ACL_CHANGE_START';
export function actionMultiAclStart({ prefixes = [], keys = [] }) {
    return {
        type: BUCKET_OBJECTS_MULTI_ACL_CHANGE_START,
        data: { prefixes, keys },
    };
}

export const BUCKET_OBJECTS_MULTI_ACL_CHANGE_CANCEL =
    'BUCKET_OBJECTS_MULTI_ACL_CHANGE_CANCEL';
export function actionMultiAclCancel() {
    return {
        type: BUCKET_OBJECTS_MULTI_ACL_CHANGE_CANCEL,
    };
}

export const BUCKET_OBJECTS_MULTI_ACL_CHANGE_REQUEST =
    'BUCKET_OBJECTS_MULTI_ACL_CHANGE_REQUEST';
function actionMultiAclChangeRequest() {
    return {
        type: BUCKET_OBJECTS_MULTI_ACL_CHANGE_REQUEST,
    };
}

export const BUCKET_OBJECTS_MULTI_ACL_CHANGE_SUCCESS =
    'BUCKET_OBJECTS_MULTI_ACL_CHANGE_SUCCESS';
function actionMultiAclChangeReceive() {
    return {
        type: BUCKET_OBJECTS_MULTI_ACL_CHANGE_SUCCESS,
    };
}

export const BUCKET_OBJECTS_MULTI_ACL_CHANGE_FAILURE =
    'BUCKET_OBJECTS_MULTI_ACL_CHANGE_FAILURE';
function actionMultiAclChangeFailure() {
    return {
        type: BUCKET_OBJECTS_MULTI_ACL_CHANGE_FAILURE,
    };
}

export function asyncActionMultiAclChange({ Bucket, ACL, prefixes, keys }) {
    return async function(dispatch) {
        dispatch(actionMultiAclChangeRequest());

        const all = keys.length + prefixes.length;
        const changedObjects = {};
        const changedPrefixes = {};

        try {
            for (const Prefix of prefixes) {
                await s3.applyOperationToObjectsByPrefix('putObjectAcl', {
                    Bucket,
                    Prefix,
                    ACL,
                });

                changedPrefixes[Prefix] = true;
            }

            for (const Key of keys) {
                await s3('putObjectAcl', { Bucket, Key, ACL });

                changedObjects[Key] = true;
            }

            dispatch(actionMultiAclChangeReceive());
            ToastNotify.success(
                `${
                    ACL === ACL_PRIVATE ? 'Закрыт' : 'Открыт'
                } доступ к\u00A0${all} ${plural(all, [
                    'объекту',
                    'объектам',
                    'объектам',
                ])}`,
            );
        } catch (reason) {
            dispatch(actionMultiAclChangeFailure());

            const allChanged =
                Object.keys(changedPrefixes).length +
                Object.keys(changedObjects).length;

            ToastNotify.error(
                'Не удалось изменить доступ' +
                    (all > 1
                        ? ` к\u00A0${all - allChanged} из\u00A0${all}`
                        : ''),
            );
        }
    };
}
